// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f45c9980","453":"95325561","667":"b2650670"}[chunkId] + ".chunk.js";
};